<template>
    <v-form name="set-status-form">
        <div class="grid">
            <FormSelect fieldName="status_id"
                        label="Status"
                        validation="required"
                        showClear
                        :change="onChangeStatus"
                        :options="statuses"
                        v-model:field="status_id" />
        </div>
        <div v-if="isSuspendStatus"
             class="grid">
            <FormSelect fieldName="dctsuspendreason_id"
                        label="Suspended reason"
                        validation="required"
                        :options="dctSuspended"
                        v-model:field="dctsuspended_id" />
        </div>
        <div v-if="isLostStatus"
             class="grid">
            <FormSelect fieldName="dctlostreason_id"
                        label="Lost reason"
                        validation="required"
                        :options="dctLost"
                        v-model:field="dctlost_id" />
        </div>

        <div class="grid"
             style="margin-top:20px">
            <Button @click.stop="setStatus"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-floppy-disk"></i><span>{{ __('Save') }}</span></template>
            </Button>

            <Button @click.stop="cancel"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Button from 'primevue/button';
import FormSelect from '@crud/FormSelect.vue'
import { __, getFromRoute, screenMessage, buttonClass } from '@pages/Helper/utils.js'
import { validation } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    opportunityData: Object,
    formProps: Object,
    statuses: Array,
    dctSuspended: Array,
    dctLost: Array,
})

const isSetStatusModalOpen = defineModel('isSetStatusModalOpen')

const select = ref(null);

const statuses = ref(props.statuses)
const dctsuspended_id = ref(null)
const dctlost_id = ref(null)
const status_id = ref(null)
const isSuspendStatus = ref(false)
const isLostStatus = ref(false)

// -----------------------------------------------------

onMounted(() => {
    statuses.value = statuses.value.filter(s => ['SYM_WON', 'SYM_LOST', 'SYM_SUSPENDED'].includes(s.status_symbol))
})

// -----------------------------------------------------

const cancel = () => {
    isSetStatusModalOpen.value = false
}

// -----------------------------------------------------

const setStatus = async () => {
    const formData = {
        status_id: status_id.value,
        dctsuspendreason_id: isSuspendStatus.value ? dctsuspended_id.value : null,
        dctlostreason_id: isLostStatus.value ? dctlost_id.value : null,
        id: props.opportunityData.id,
    }

    if (validation(formData, 'set-status-form')) {
        const response = await getFromRoute('opportunity-status-set', formData, 'post');
        screenMessage({ ...response })

        isSetStatusModalOpen.value = false
        props.formProps.closeModal()
        props.formProps.getLazyData()
    }
}

// -----------------------------------------------------

const onChangeStatus = () => {
    const selectedStatus = statuses.value.find(s => s.value === status_id.value);
    if (selectedStatus) {
        isSuspendStatus.value = selectedStatus.status_symbol === 'SYM_SUSPENDED';
        isLostStatus.value = selectedStatus.status_symbol === 'SYM_LOST';
    } else {
        isSuspendStatus.value = false;
        isLostStatus.value = false;
    }
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
